import { useLocation } from '@tanstack/react-router';
import WorkbenchLink from '@zeus/core/WorkbenchLink';
import { OrganizationContext } from '_/contexts/OrganizationContext';
import React, { ReactElement, useMemo, useContext } from 'react';

interface Snapshot {
  id: string;
  source?: {
    slug: string;
    collection?: {
      slug: string;
      project?: {
        slug: string;
        org?: { slug: string };
      };
    };
  };
}

interface SnapshotViewLinkProps {
  snapshot: Snapshot;
}

function SnapshotViewLink({ snapshot }: SnapshotViewLinkProps): ReactElement | null {
  const collectionSlug = snapshot?.source?.collection?.slug;
  const orgContext = useContext(OrganizationContext);
  const orgSlug = orgContext?.selectedOrgSlug || snapshot?.source?.collection?.project?.org?.slug;
  const projectSlug = snapshot?.source?.collection?.project?.slug;
  const location = useLocation();
  const publicToken = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('token') || '';
  }, [location.search]);
  const sourceSlug = snapshot?.source?.slug;

  if (publicToken || !orgSlug || !projectSlug || !collectionSlug || !sourceSlug) {
    return null;
  } else {
    return (
      <WorkbenchLink
        href={`/orgs/${orgSlug}/projects/${projectSlug}/collections/${collectionSlug}/sources/${sourceSlug}/snapshots/${snapshot.id}`}
      >
        View
      </WorkbenchLink>
    );
  }
}

export default SnapshotViewLink;
